// @flow
// libs
import React, {useEffect, useState} from 'react';
import IMAGES from '../../constans/images';
import {Dropdown, DropdownButton} from "react-bootstrap";

type Props = {
    handleClick: Function,
    isDisabled?: any,
    customClass?: string,
};

const DropDownCommon = ({
                    isDisabled = false,
                    handleClick,
                    customClass = '',
                    errorMes = '',
                    dataList = [],
                    idActive = '',
                    nameDisplay = '',
                    keyId='id',
                    keyName='name'
                }: Props) => {

    const [nameShow, setNameShow] = useState('');

    useEffect(() => {
        if(idActive){
            let nameActive = dataList.length > 0 && dataList.filter(item =>item[keyId] == idActive)
            if(nameActive && nameActive.length > 0) {
                setNameShow(nameActive[0][keyName])
            }
        }
    }, [idActive]);

    useEffect(() => {
        setNameShow(nameDisplay)
    }, [nameDisplay]);

    const _handleClick = (data) => {

        if(typeof handleClick == 'function') {
            setNameShow(data[keyName])
            handleClick(data)
        }
    }


    return (
        <div className={'input-group select-type dropdown-common '+ customClass + (errorMes ? ' error-show' : '')}>

            <DropdownButton id="dropdown-item-button" title={`${nameShow}`} className={nameShow === '선택해주세요.' ? 'placeholder' : ''}>
                {dataList.map((item,index) => (
                    <Dropdown.Item as="button" className={idActive == item[keyId] ? 'active' : ''} key={index} onClick={()=>_handleClick(item)}>
                        {item[keyName]}
                    </Dropdown.Item>
                ))}
            </DropdownButton>
            <img className={'icon-arrow-down'} src={'/images/icon_arrowdown.svg'} />
        </div>
    );
};

DropDownCommon.defaultProps = {
    isDisabled: false,
    customClass: '',
    placeHolder: '',
};

export default DropDownCommon;
